module.exports = __webpack_public_path__ + "static/media/marker-no.76007279.svg";